var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 26,
    viewBox: "0 0 210 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_EN",
    transform: "translate(-142.24 -357.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_333",
    transform: "translate(142.24 357.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1058",
    fill: "#ad002a",
    d: "M154.664 381.837a12.358 12.358 0 1 0-12.424-12.355 12.39 12.39 0 0 0 12.424 12.355",
    transform: "translate(-142.24 -357.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1059",
    d: "M172.967 375.079v10.842h3.463v-.975h-2.465v-9.868z",
    className: "cls-2",
    transform: "translate(-161.043 -368.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1060",
    d: "M161.686 378.026a1.483 1.483 0 1 0-1.488-1.481 1.485 1.485 0 0 0 1.488 1.481",
    className: "cls-2",
    transform: "translate(-153.229 -368.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1061",
    d: "M158.356 362.322c-.13-.006-.377-.015-.495-.015a10.392 10.392 0 0 0-10.4 10.352 10.267 10.267 0 0 0 3.041 7.322 10.45 10.45 0 0 0 14.707 0 10.257 10.257 0 0 0 3.051-7.322v-.46h-7.43v.953h6.437v.148a9.437 9.437 0 0 1-16.069 5.991 9.329 9.329 0 0 1 0-13.265 9.389 9.389 0 0 1 6.667-2.747c.109 0 .373 0 .495.006z",
    className: "cls-2",
    transform: "translate(-145.434 -360.304)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_336",
    transform: "translate(172.702 361.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1062",
    d: "M224.472 367.9h-3.736V384h11.474v-3.135h-7.738z",
    className: "cls-3",
    transform: "translate(-220.735 -367.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1063",
    d: "M259.236 377.478h3.042v2.815a8.611 8.611 0 0 1-2.7.426c-3.362 0-4.482-1.7-4.482-5.154 0-3.292 1.066-5.232 4.429-5.232a4.334 4.334 0 0 1 3.816 1.7l2.323-2.124c-1.415-2.019-3.9-2.63-6.219-2.63-5.23 0-7.979 2.841-7.979 8.261 0 5.392 2.482 8.314 7.952 8.314a11.943 11.943 0 0 0 6.3-1.568v-7.808h-6.485z",
    className: "cls-3",
    transform: "translate(-239.543 -367.278)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_335",
    transform: "translate(31.831 0.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1064",
    d: "M306.077 377.172h6.971v-2.727h-6.971v-3.68h7.216v-2.749h-10.534v16.072h10.8V381.3h-7.483z",
    className: "cls-3",
    transform: "translate(-302.759 -367.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1065",
    d: "M340.671 380.01a6.7 6.7 0 0 0-3.563.953v-.688h-3.185v11.173h3.229v-8.225a3.662 3.662 0 0 1 1.87-.576c1.581 0 1.915.62 1.915 1.862v6.939h3.229v-7.715c.001-2.238-.8-3.723-3.495-3.723z",
    className: "cls-3",
    transform: "translate(-321.829 -375.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1066",
    d: "M399.767 379.953a4.416 4.416 0 0 0-2.985 1.2v-.91h-3.117v11.173h3.229v-7.692a3.4 3.4 0 0 1 2.628-1.153 3.613 3.613 0 0 1 1.581.355l.735-2.594a4.8 4.8 0 0 0-2.071-.379z",
    className: "cls-3",
    transform: "translate(-358.387 -375.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1067",
    d: "M369.335 379.952c-3.585 0-5.456 2.128-5.456 5.809 0 3.9 1.426 5.919 5.613 5.919a9.3 9.3 0 0 0 4.677-1.174l-.6-2.106a8.449 8.449 0 0 1-3.5.842 3.381 3.381 0 0 1-2.339-.709 3.018 3.018 0 0 1-.623-2h7.26v-1c.002-3.186-1.446-5.581-5.032-5.581zm-2.227 4.523c.045-1.551.8-2.306 2.137-2.306 1.381 0 1.938.954 1.938 2.306z",
    className: "cls-3",
    transform: "translate(-340.16 -375.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1068",
    d: "M421.75 380.662a5.151 5.151 0 0 0-2.606-.71c-4.031 0-5.278 2.528-5.278 6.252 0 3.3 1.492 5.475 4.9 5.475a8.829 8.829 0 0 0 2.472-.31v1c0 1.728-.98 2.305-2.85 2.305a6.6 6.6 0 0 1-2.784-.621l-.758 2.306a8.62 8.62 0 0 0 3.741.776c3.319 0 5.9-1.463 5.9-5.431v-11.53h-2.561zm-.534 8.446a4.224 4.224 0 0 1-1.292.177c-1.737 0-2.784-.82-2.784-3.392 0-2.682.912-3.525 2.694-3.525a3.337 3.337 0 0 1 1.382.288z",
    className: "cls-3",
    transform: "translate(-370.748 -375.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1069",
    d: "M450.116 388.125h-.424l-2.383-7.427h-3.429l4.521 11.2c-.668 2.394-1.56 2.837-3.23 2.837a4.768 4.768 0 0 1-.869-.066l-.378 2.505a6.976 6.976 0 0 0 1.692.155c2.94 0 4.343-1.507 5.456-4.5l4.478-12.129h-3.207z",
    className: "cls-3",
    transform: "translate(-389.115 -375.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1070",
    d: "M663.726 380.01a6.7 6.7 0 0 0-3.563.953v-.688h-3.185v11.173h3.229v-8.225a3.664 3.664 0 0 1 1.871-.576c1.581 0 1.916.62 1.916 1.862v6.939h3.229v-7.715c0-2.238-.803-3.723-3.497-3.723z",
    className: "cls-3",
    transform: "translate(-519.516 -375.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1071",
    d: "M491.407 374.988c-.6-.244-1.737-.6-2.339-.776-2-.554-3.1-1.064-3.1-2.372 0-.975.646-1.729 2.851-1.729a8.752 8.752 0 0 1 4.209 1.153l1.159-2.572a11.893 11.893 0 0 0-5.435-1.308c-4.3 0-6.281 1.906-6.281 4.633 0 2.35 1.782 3.769 3.719 4.523.958.355 2.027.709 2.829.931 1.291.355 1.8.976 1.8 1.862 0 1.109-.779 1.773-2.828 1.773a9.273 9.273 0 0 1-4.543-1.308l-1.226 2.7a12.393 12.393 0 0 0 5.791 1.464c4.008 0 6.347-1.995 6.347-4.766.009-2.612-1.394-3.543-2.953-4.208z",
    className: "cls-3",
    transform: "translate(-412.583 -367.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1072",
    d: "M521.988 379.952c-4.1 0-5.835 1.928-5.835 5.83 0 3.658 1.247 5.9 5.367 5.9 3.987 0 5.857-1.884 5.857-5.786.001-3.816-1.247-5.944-5.389-5.944zm-.4 9.4c-1.692 0-2.16-1.308-2.16-3.547 0-2.528.534-3.525 2.495-3.525 1.8 0 2.183 1.33 2.183 3.414-.006 2.571-.492 3.658-2.519 3.658z",
    className: "cls-3",
    transform: "translate(-433.341 -375.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1073",
    d: "M631.556 379.952c-4.1 0-5.835 1.928-5.835 5.83 0 3.658 1.247 5.9 5.367 5.9 3.986 0 5.857-1.884 5.857-5.786.001-3.816-1.245-5.944-5.389-5.944zm-.4 9.4c-1.693 0-2.16-1.308-2.16-3.547 0-2.528.534-3.525 2.495-3.525 1.8 0 2.182 1.33 2.182 3.414-.001 2.571-.492 3.658-2.518 3.658z",
    className: "cls-3",
    transform: "translate(-500.388 -375.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_779",
    d: "M0 0H3.252V16.14H0z",
    className: "cls-3",
    transform: "translate(95.257 0.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_780",
    d: "M0 0H3.23V11.173H0z",
    className: "cls-3",
    transform: "translate(121.114 5.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_781",
    d: "M0 0H3.274V2.594H0z",
    className: "cls-3",
    transform: "translate(121.092 0.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1074",
    d: "M595.146 385.239c-1.069 0-1.462-.355-1.462-1.774v-4.5h3.688v-2.527h-3.688v-2.682l-3.122.62v2.062h-1.9v2.505h1.9v4.922c0 2.948.894 4.012 3.426 4.012a8.051 8.051 0 0 0 3.821-.887l-.458-2.306a5.211 5.211 0 0 1-2.205.555z",
    className: "cls-3",
    transform: "translate(-477.712 -371.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1075",
    d: "M567.707 388.88a3.177 3.177 0 0 1-1.812.62c-1.462 0-1.789-.376-1.789-1.817V380.7h-3.122v7.715c0 2.238.763 3.724 3.449 3.724a6.135 6.135 0 0 0 3.382-.934l-.007.667h3.021V380.7h-3.122z",
    className: "cls-3",
    transform: "translate(-460.774 -375.556)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLg);
export default __webpack_public_path__ + "static/media/c_lg.2fd3f58833652df8c3bdea5373289bb0.svg";
export { ForwardRef as ReactComponent };